import { createSelector } from '@reduxjs/toolkit';

import { emptyConsumerSession, SESSION_META_KEYS } from './consumerSession';

const selectConsumerState = (state) => state.consumer;

export const selectConsumerSession = createSelector(
  [selectConsumerState],
  (consumer) => consumer?.session ?? emptyConsumerSession,
);

export const selectConsumerSessionCredentials = createSelector([selectConsumerSession], (session) =>
  Object.fromEntries(Object.entries(session ?? emptyConsumerSession).filter(([key]) => !SESSION_META_KEYS.has(key))),
);
